module.exports = __webpack_public_path__ + "static/dota2-3085af94086d9bf6e7f510b6bedd5090.svg";